import Color from "color";

import { ThemePlusTypes } from "@styles/types";
import { PalletThemeColors } from "@styles/utils";

export default (colors: PalletThemeColors): ThemePlusTypes["productFruits"] => {
  return {
    checklistToggleButton: {
      background: Color(colors.primary.lightest).alpha(0.25).string(),
      backgroundCollapsed: colors.primary.base,
      text: colors.secondary.lightest,
      backgroundHover: colors.primary.dark,
      backgroundActive: colors.primary.darker,
      backgroundGlowKeyframe: Color(colors.secondary.lightest).alpha(0.8).string(),
    },
  };
};
